import SiteHead from 'components/site-head';
import Footer from 'components/footer';
import NavBarNoAuth from 'components/nav-bar-no-auth';
import React, { ReactElement } from 'react';

export function MDXWrapper({
  children,
  ...props
}: {
  children: ReactElement[];
  metadata: {
    title: string;
    description: string;
    language: string;
    availableLanguages?: string[];
  };
}): ReactElement {
  return (
    <>
      <SiteHead
        title={props.metadata.title}
        description={props.metadata.description}
        language={props.metadata.language}
        availableLanguages={props.metadata.availableLanguages}
      />
      <NavBarNoAuth />
      <article className="prose prose-sm sm:prose lg:prose-lg xl:prose-xl mx-4 sm:mx-auto my-4">
        {children}
      </article>
      <Footer />
    </>
  );
}
